import { useEffect, useRef } from "react";
import { initSentry } from "@/sentry.ts";

export const useSentry = () => {
    const sentryInitializedRef = useRef(false);

    useEffect(() => {
        if (!sentryInitializedRef.current) {
            initSentry();
            sentryInitializedRef.current = true;
        }
    }, []);
};
